<template>
  <b-dropdown
    v-b-tooltip.hover
    split
    variant="outline-light"
    menu-class="p-4"
    class="d-inline-block"
    :title="tooltip"
    :toggle-class="menuDisabled ? 'd-none' : 'd-inline-block'"
    @click="onButtonClick"
  >
    <template #button-content>
      <slot name="placeholder" />
    </template>

    <div
      class="d-flex flex-column align-items-start"
      style="gap: 8px; min-width: 150px;"
    >
      <label>{{ label }}</label>
      <b-form-input
        v-model="localValue"
        type="number"
        :min="min"
        :step="step"
        style="width: 98px"
        @input="emitChange"
      />
    </div>
  </b-dropdown>
</template>

<script>
export default {
  name: 'DropdownSlider',
  props: {
    label: {
      type: String,
      default: ''
    },
    min: {
      type: Number,
      default: 1
    },
    step: {
      type: Number,
      default: 1
    },
    value: {
      type: [Number, String],
      default: 0
    },
    tooltip: {
      type: String,
      default: ''
    },
    menuDisabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ['change'],
  data() {
    return {
      localValue: this.value
    };
  },
  watch: {
    value(newVal) {
      this.localValue = newVal;
    }
  },
  methods: {
    emitChange() {
      this.$emit('change', Number(this.localValue));
    },
    onButtonClick() {
      this.$emit('change', Number(this.localValue));
    }
  }
};
</script>

<style scoped lang="scss">
::v-deep {
  .btn {
    color: #000000;
  }

  .dropdown-toggle {
    padding: 2px 5px 4px 7px;
    color: #000000;
  }

  label {
    font-family: "Nunito", sans-serif;
    font-size: 14px;
    color: #464646;
    font-weight: 500;
    line-height: 24px;
    cursor: inherit;
    margin-bottom: 0;
  }

  .input-group-text {
    cursor: pointer;
    color: #000000;
  }

  .dropdown-menu {
    min-width: max-content;
  }
}
</style>
